import { Hidden } from "@mui/material";
import MobileFormStepper from "./FormStepper/MobileFormStepper";
import WebFormStepper from "./FormStepper/WebFormStepper";

const FormStepper = (props) => {
  return (
    <div>
    <Hidden smUp>
        <MobileFormStepper {...props} />
        </Hidden>
        <Hidden smDown>
        <WebFormStepper {...props} />
        </Hidden>
    </div>
  )
};
export default FormStepper;
